export const FAILURE_REASONS = {
  TOO_MANY_PREVIOUS_CLAIMS: 'The user has selected an unsupported number of previous claims',
  PREVIOUS_INSURANCE_VOIDED: 'The previous insurance has cancelled the user old policy',
  PRIMARY_RESIDENCE_NOT_GERMANY: 'The user is not having the primary residence in Germany',
  NO_EXISTING_HEALTH_INSURANCE: 'The user doesnt have any health insurance',
  TOO_MANY_MISSING_TEETH: 'The user has too many missing teeth',
  EXISTING_INSURANCE: 'The user will have an existing insurance at the starting date',
  REMOVABLE_TEETH: 'The user has removable false teeth',
  STATEMENT_OF_FACTS_MANDATORY: 'The user has an false value for one of the statements',
  PREVIOUS_CLAIM_EXCESSIVE_AMOUNT:
    'The user has a previous insurance claim with a value of 2500 or more',
  NON_SUPPORTED_FLOOR: 'The user wants to insure an unsupported floor value',
  NON_SUPPORTED_PROPERTY: 'The user wants to insure an unsupported property value',
  TOO_MANY_PEOPLE_TO_INSURE: 'Too many people are living in the home to insure',
  WRONG_COVERAGE_PLAN_FOR_CURRENT_SITUATION:
    'The user has selected a tariff type that cannot match its status',
  WRONG_RESIDENT_OCCUPATION: 'The user wants to insure the house with wrong resident occupation',
  DRONE_TOO_HEAVY: 'The drone is too heavy to be insured',
  HAS_PERIODONTAL_DISEASE: 'The user has treated periodontal disease in the last 3 years',
}
